import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Subject, Subscription } from "rxjs";

export type ScreenSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'unknown'

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService implements OnDestroy {

  readonly BREAKPOINTS = [
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]

  private _sub?: Subscription
  private _sz: ScreenSize = 'unknown'

  get screenSize(): ScreenSize {
    return this._sz
  }

  public readonly screenSizeChange = new Subject<ScreenSize>()

  constructor(
    private readonly screenSizeDetector: BreakpointObserver) {
    this.subscribe()
  }

  ngOnDestroy(): void {
    this.unsubscribe()
  }

  invalidate(): void {
    for (const k in this.BREAKPOINTS) {
      if (this.screenSizeDetector.isMatched(this.BREAKPOINTS[k])) {
        switch (this.BREAKPOINTS[k]) {
          case Breakpoints.XSmall:
            this._sz = 'xs'
            this.screenSizeChange.next('xs');
            break;
          case Breakpoints.Small:
            this._sz = 'sm'
            this.screenSizeChange.next('sm');
            break;
          case Breakpoints.Medium:
            this._sz = 'md'
            this.screenSizeChange.next('md');
            break;
          case Breakpoints.Large:
            this._sz = 'lg'
            this.screenSizeChange.next('lg');
            break;
          case Breakpoints.XLarge:
            this._sz = 'xl'
            this.screenSizeChange.next('xl');
            break;
          default:
            this._sz = 'unknown'
            this.screenSizeChange.next('unknown')
        }
        break
      }
    }
  }

  subscribe(): void {
    this.unsubscribe()
    this._sub = this.screenSizeDetector.observe(this.BREAKPOINTS).subscribe(r => {
      if (r.matches) {
        for (const k in r.breakpoints) {
          if (r.breakpoints[k]) {
            switch (k) {
              case Breakpoints.XSmall:
                this._sz = 'xs'
                this.screenSizeChange.next('xs');
                break;
              case Breakpoints.Small:
                this._sz = 'sm'
                this.screenSizeChange.next('sm');
                break;
              case Breakpoints.Medium:
                this._sz = 'md'
                this.screenSizeChange.next('md');
                break;
              case Breakpoints.Large:
                this._sz = 'lg'
                this.screenSizeChange.next('lg');
                break;
              case Breakpoints.XLarge:
                this._sz = 'xl'
                this.screenSizeChange.next('xl');
                break;
              default:
                this._sz = 'unknown'
                this.screenSizeChange.next('unknown')
            }
            break
          }
        }
      }
      else {
        this._sz = 'unknown'
        this.screenSizeChange.next('unknown')
      }
    })
  }

  unsubscribe(): void {
    this._sub?.unsubscribe()
    this._sub = undefined
  }
}
